import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControls: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGamepadControls"><Path d="M8 2V7.16421L12 11.1642L16 7.16421V2H8Z" fill="currentColor"/><Path d="M2 8V16H7.16421L11.1642 12L7.16421 8H2Z" fill="currentColor"/><Path d="M16.8358 8L12.8358 12L16.8358 16H22V8H16.8358Z" fill="currentColor"/><Path d="M12 12.8358L8 16.8358V22.25H16V16.8358L12 12.8358Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControls;
